// Event-query domain primitives shared by the backend services and the admin
// filter UI. Pure (no runtime dependencies) so any app can import them — via the
// `.` barrel or the granular `@logspot-platform/platform-types/events` subpath —
// without pulling anything heavy. Previously duplicated in
// `apps/backend/src/services/event-types.ts`, the public-analytics wrapper, and
// `apps/admin` (`filter-dialog-button.tsx` Operator, `types.ts` Filter).

/** SQL comparison operators used by event search / analytics filters. */
export enum Operator {
  EQ = '=',
  GTE = '>=',
  LTE = '<=',
  LT = '<',
  GT = '>',
  NEQ = '<>',
  NULL = 'IS NULL',
  NOT_NULL = 'IS NOT NULL',
}

/**
 * A single filter clause (internal/service shape, camelCase). `value` is
 * optional: `IS NULL` / `IS NOT NULL` carry none, and the query builder guards
 * those operators before reading it.
 */
export type Filter = {
  fieldName: string;
  operator: Operator;
  value?: string | number | boolean;
};

export type FilterGroup = {
  filters: Filter[];
};

/** Dimensions the `/aggregate` analytics endpoint can group by. */
export enum AggregateField {
  location_country = 'location_country',
  location_city = 'location_city',
  location_region = 'location_region',
  device = 'device',
  os = 'os',
  browser = 'browser',
  screen = 'screen',
  language = 'language',
  referrer = 'referrer',
  url = 'url',
  // Per-session derivation (first page of the session), so its counts are
  // sessions started, not pageviews.
  entry_url = 'entry_url',
  hostname = 'hostname',
  user_id = 'user_id',
  // Derived at read time from referrer + utm_source/utm_medium, not a column.
  acquisition_channel = 'acquisition_channel',
}
